import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const initDripServicesListLoadMore = () => {
    const section = document.querySelector(".drip-services-list");
    if (!section) return;

    const loadMoreBtn = section.querySelector("[data-drip-services-load-more]");
    if (!loadMoreBtn) return;

    clickOn("[data-drip-services-load-more]", (event, trigger) => {
        event.preventDefault();

        section.querySelectorAll(".drip-services-list__item--hidden-mobile").forEach((item) => {
            item.classList.remove("drip-services-list__item--hidden-mobile");
        });

        const wrapper = trigger.closest(".drip-services-list__load-more");
        if (wrapper) {
            wrapper.style.display = "none";
        }
    });
};

load(initDripServicesListLoadMore);

